import { render, staticRenderFns } from "./AspectRatioBox.vue?vue&type=template&id=80e2cbe0"
import script from "./AspectRatioBox.vue?vue&type=script&lang=js"
export * from "./AspectRatioBox.vue?vue&type=script&lang=js"
import style0 from "./AspectRatioBox.vue?vue&type=style&index=0&id=80e2cbe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports